export default "__VITE_ASSET__617cb85b__"